import React, { useState } from 'react';
import Icon from '../AppIcon';
import PINEntryModal from './PINEntryModal';
import { validatePIN, unlockSession } from '../../utils/parentalLockService';

const ParentalLockOverlay = ({ children, message = 'This section is protected by parental lock' }) => {
  const [showPINModal, setShowPINModal] = useState(false);

  const handleUnlock = async (pin) => {
    const isValid = validatePIN(pin);
    
    if (isValid) {
      unlockSession();
      setShowPINModal(false);
      // Force re-render of parent component
      window.location?.reload();
      return true;
    }
    
    return false;
  };

  return (
    <>
      <div className="relative">
        {/* Blurred Content */}
        <div className="filter blur-sm pointer-events-none select-none">
          {children}
        </div>

        {/* Lock Overlay */}
        <div className="absolute inset-0 bg-background/80 backdrop-blur-sm flex items-center justify-center">
          <div className="text-center space-y-4 max-w-md px-6">
            <div className="w-16 h-16 mx-auto rounded-full bg-warning/10 flex items-center justify-center">
              <Icon name="lock" size={32} className="text-warning" />
            </div>
            <h3 className="text-h3 font-heading text-foreground">
              Protected Content
            </h3>
            <p className="text-muted-foreground">
              {message}
            </p>
            <button
              onClick={() => setShowPINModal(true)}
              className="inline-flex items-center gap-2 px-6 py-3 bg-primary text-primary-foreground rounded-lg hover:bg-primary/90 transition-colors font-medium"
            >
              <Icon name="unlock" size={18} />
              Unlock with PIN
            </button>
          </div>
        </div>
      </div>

      {/* PIN Entry Modal */}
      {showPINModal && (
        <PINEntryModal
          title="Unlock Content"
          description="Enter your 4-digit parental lock PIN to access this content"
          onClose={() => setShowPINModal(false)}
          onSubmit={handleUnlock}
          submitLabel="Unlock"
        />
      )}
    </>
  );
};

export default ParentalLockOverlay;
